import { Visibility, VisibilityOff } from '@mui/icons-material'
import { TextField, FormControl, InputLabel, Input, InputAdornment, IconButton, Box, Button, FormHelperText } from '@mui/material'
import { createUserWithEmailAndPassword } from 'firebase/auth'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { auth } from '../../firebase/init'

type Props = {
  from: string
}
const SignUp: React.FC<Props> = ({from}) => {
  const navigate = useNavigate()
  const [form_data, setFormData] = useState<{
    email: string, password: string, password_again: string
  }>({email: '', password: '', password_again: ''})
  const [password_visible, setPasswordVisible] = useState(false)

  return <form
    onSubmit={async e=> {
      e.preventDefault()
      const form_data = new FormData(e.currentTarget)
      const email = form_data.get('email') as string
      const password = form_data.get('password') as string
      const result = await createUserWithEmailAndPassword(auth, email, password)
        .then(uc=> uc.user)
        .catch((err: Error)=> {
          console.error(err)
          return err
        })
      if (result instanceof Error) {
        console.error(result)
        alert(result.message)
        return
      }
      navigate(from)
    }}
  >
    <TextField
      variant='standard' fullWidth
      name='email' type='text' label='Email'
      autoComplete='email'
      value={form_data.email}
      onChange={e=> { setFormData({...form_data, email: e.target.value}) }}
      placeholder='Username' required
      sx={{mt: 2}}
    />

    <FormControl variant='standard' sx={{mt: 2}} fullWidth>
      <InputLabel htmlFor="password">Password</InputLabel>
      <Input
        name='password'
        id='password'
        type={password_visible ? 'text' : 'password'}
        autoComplete='new-password'
        placeholder='Password' required
        value={form_data.password}
        onChange={e=> { setFormData({...form_data, password: e.target.value}) }}
        endAdornment={
          <InputAdornment position='end'>
            <IconButton
              onClick={()=> { setPasswordVisible(!password_visible) }}
            >
              {password_visible ? <Visibility/> : <VisibilityOff/>}
            </IconButton>
          </InputAdornment>
        }
      />
    </FormControl>

    <FormControl
      variant='standard' sx={{mt: 2}} fullWidth
    >
      <InputLabel htmlFor='password_again'>Password(確認)</InputLabel>
      <Input
        id='password_again'
        type={password_visible ? 'text' : 'password'}
        autoComplete='new-password'
        placeholder='Password' required
        value={form_data.password_again}
        onChange={e=> { setFormData({...form_data, password_again: e.target.value}) }}
        endAdornment={
          <InputAdornment position='end'>
            <IconButton
              onClick={()=> { setPasswordVisible(!password_visible) }}
            >
              {password_visible ? <Visibility/> : <VisibilityOff/>}
            </IconButton>
          </InputAdornment>
        }
      />
      {form_data.password !== form_data.password_again && Boolean(form_data.password_again) &&
        <FormHelperText color='red'>パスワードが一致しません</FormHelperText>}
    </FormControl>

    <Box textAlign='center'>
      <Button
        disabled={!(
          Object.values(form_data).every(s=> s)
          && form_data.password === form_data.password_again
        )}
        type='submit' variant='contained' color='primary'
        sx={{mt: 4}}
      >
        新規登録
      </Button>
    </Box>
  </form>
}
export default SignUp
